import { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase';

export default function PaymentGateway() {
  const [status, setStatus] = useState('loading'); // 'loading' | 'error'
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const regId = params?.get('regId');

    if (!regId) {
      setStatus('error');
      setErrorMsg('Geçersiz ödeme bağlantısı. Lütfen e-postanızdaki linki tekrar kullanın.');
      return;
    }

    async function fetchAndRedirect() {
      try {
        const { data, error } = await supabase?.functions?.invoke('process-custom-payment', {
          body: { intent: 'get_link_by_id', registrationId: regId }
        });

        if (error) throw new Error(error.message || 'Servis hatası oluştu.');

        const link = data?.payment_link;
        if (!link) throw new Error('Ödeme linki bulunamadı veya süresi doldu.');

        if (link?.startsWith('data:text/html;base64,')) {
          const base64Content = link?.split(',')?.[1];
          const decodedHtml = decodeURIComponent(escape(atob(base64Content)));
          document.open();
          document.write(decodedHtml);
          document.close();
        } else {
          window.location.href = link;
        }
      } catch (err) {
        console.error('Gateway error:', err);
        setStatus('error');
        setErrorMsg(err?.message || 'Ödeme sayfasına yönlendirilemedi.');
      }
    }

    fetchAndRedirect();
  }, []);

  if (status === 'error') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full text-center">
          {/* Brand logo / name */}
          <div className="mb-6">
            <span className="text-2xl font-bold text-emerald-600">PaddleTürkiye</span>
          </div>

          {/* Error icon */}
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-5">
            <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>

          <h2 className="text-xl font-bold text-gray-900 mb-2">Ödeme Sayfası Yüklenemedi</h2>
          <p className="text-gray-500 text-sm mb-7 leading-relaxed">{errorMsg}</p>

          <a
            href="mailto:info@paddleturkiye.com"
            className="inline-flex items-center justify-center gap-2 w-full bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-3 px-6 rounded-xl transition-colors duration-200"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            Yönetici ile İletişime Geçin
          </a>

          <a href="/" className="block mt-3 text-sm text-gray-400 hover:text-gray-600 transition-colors">
            Ana Sayfaya Dön
          </a>
        </div>
      </div>
    );
  }

  // Loading / redirecting state — brand-green spinner
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white rounded-2xl shadow-lg p-10 max-w-sm w-full text-center">
        {/* Brand name */}
        <div className="mb-8">
          <span className="text-2xl font-bold text-emerald-600">PaddleTürkiye</span>
        </div>

        {/* Brand-green spinner */}
        <div className="flex justify-center mb-6">
          <div className="w-14 h-14 border-4 border-emerald-100 border-t-emerald-600 rounded-full animate-spin"></div>
        </div>

        <p className="text-gray-800 font-semibold text-base leading-snug mb-2">
          PaddleTürkiye Ödeme Sayfasına Yönlendiriliyorsunuz...
        </p>
        <p className="text-gray-400 text-sm">Bu işlem birkaç saniye sürebilir, lütfen bekleyin.</p>
      </div>
    </div>
  );
}
